module.exports = __webpack_public_path__ + "static/hello-5dfe092cf8805fe7f4767543cd5d81ad.png";